// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cjUC","header":"ReportDetails_header__128lp","title":"ReportDetails_title__2B_ou","left":"ReportDetails_left__qfutB"};